// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------------------------------------------
    Container
----------------------------------------------------- */

.root2 {
  background: #007bff;
  height: 100vh;
}



#loginSistem {
  padding: 8% 0 0;
  margin-left: 35%;

}

.row {
  width: 98%;
}


.formgroupbotaologin{
  justify-content: space-between;
}

/* ---------------------------------------------------
    Titulo
----------------------------------------------------- */

.title {
    color: white;
    text-align: center;
    padding-top: 8%;
    width: 98%;
}

.text {
    font-size: 2.4em;
    font-weight: bold;
    margin-bottom: 10%;
    width: 98%;
}

/* ---------------------------------------------------
    Input Login
----------------------------------------------------- */

div #login {

    border-style: hidden hidden solid hidden; 
    border-bottom: 1px solid white;
    border-radius: 0%;
    background: #007bff;
    color: white;
    width: 100%;
}

.login {
    display: flex;
    flex-direction: column;
    min-width: 36px;
  }
  
  .login input {
    width: 100%;
    height: 70px;
    padding: 28px 16px 0 10px;
    outline: 0;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
  }
  
  .login label {
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif;
    padding: 0 12px;
    pointer-events: none;
    position: absolute;
    transform: translate(0, 40px) scale(1);
    transform-origin: top left;
    transition: all 0.5s ease-out;
    color: white;
  }

  .login:focus-within label {
    transform: translate(0, 12px) scale(0.75);
  }

  .login input:focus{
    border-bottom: 2px solid #3951b2;
  }

  .login .Active {
    transform: translate(0, 12px) scale(0.75);
  }

/* ---------------------------------------------------
    Input Senha
----------------------------------------------------- */

div #senha {

    border-style: hidden hidden solid hidden; 
    border-bottom: 1px solid white;
    border-radius: 0%;
    background: #007bff;
    color: white;
    width: 100%;
    right: auto;
    left: auto;
    position: relative;
}

.senha {
    display: flex;
    flex-direction: column;
    min-width: 36px;
    
  }
  
  .senha input {
    width: 100%;
    height: 70px;
    padding: 28px 16px 0 10px;
    outline: 0;
    border: 1px solid white;
    border-radius: 4px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
  }
  
  .senha label {
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif;
    padding: 0 12px;
    pointer-events: none;
    position: absolute;
    transform: translate(0, 40px) scale(1);
    transform-origin: top left;
    transition: all 0.5s ease-out;
    color: white;
  }

  .senha:focus-within label {
    transform: translate(0, 12px) scale(0.75);
  }

  .senha input:focus{
    border-bottom: 2px solid #3951b2;
  }

  .senha .Active {
    transform: translate(0, 12px) scale(0.75);
  }

/* ---------------------------------------------------
    Botão
----------------------------------------------------- */


div #buttonlogin, div #buttonsemlogin {
    margin-top: 2%;
    padding-top: 1%;
    background:white;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); 
    border: none;
    width: 30%;
    position: relative;
    float: right;
    color: #007bff;
}

/* ---------------------------------------------------
    Imagem
----------------------------------------------------- */


div #thinklogo{
    max-width: 250px;
    position: fixed;
    bottom: 30px;
    right: 50px;
}

/* ---------------------------------------------------
    Material-icons
----------------------------------------------------- */

label .material-icons {
    color: white;
    vertical-align: middle;
    transition: 0.5s; 
    padding: 0 0 0 0;
    margin-left: -1%;
}

#buttonsemlogin .material-icons, #buttonlogin .material-icons {
    color: #007bff;
    vertical-align: middle;
    transition: 0.5s; 
    padding: 0;
}


/* ---------------------------------------------------
    Tela Mobile
----------------------------------------------------- */


@media only screen and (max-width: 769px) {

    .root2 {
      background: #007bff;
      height: 100vh;
      padding: 4%;
    }


    #loginSistem {
        padding: 8% 0 8% 5%;
        margin-left: 3%;
        margin-right: 0%;
    }

    div #buttonlogin, div #buttonsemlogin {
        margin-top: 10%;
        padding-top: 1%;
        background:white;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); 
        border: none;
        position: relative;
        float: right;
        color: #007bff;

        width: 80%;
        padding: 10px 20px;
    }

    .formgroupbotaologin{
      justify-content: center;
      align-items: center;
    }

    div #thinklogo{
        width: 100%;
        height: 100%;
        position: relative;
        left: 20%;
        margin-top: 20%;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/login/Login.css"],"names":[],"mappings":"AAAA;;uDAEuD;;AAEvD;EACE,mBAAmB;EACnB,aAAa;AACf;;;;AAIA;EACE,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,8BAA8B;AAChC;;AAEA;;uDAEuD;;AAEvD;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;uDAEuD;;AAEvD;;IAEI,wCAAwC;IACxC,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yCAAyC;IACzC,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,sCAAsC;IACtC,0BAA0B;IAC1B,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yCAAyC;EAC3C;;AAEF;;uDAEuD;;AAEvD;;IAEI,wCAAwC;IACxC,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;;EAEjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yCAAyC;IACzC,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,sCAAsC;IACtC,0BAA0B;IAC1B,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yCAAyC;EAC3C;;AAEF;;uDAEuD;;;AAGvD;IACI,cAAc;IAEd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sGAAsG;IACtG,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;;uDAEuD;;;AAGvD;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;;uDAEuD;;AAEvD;IACI,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;AACd;;;AAGA;;uDAEuD;;;AAGvD;;IAEI;MACE,mBAAmB;MACnB,aAAa;MACb,WAAW;IACb;;;IAGA;QACI,mBAAmB;QACnB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QAEf,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,sGAAsG;QACtG,YAAY;QAEZ,kBAAkB;QAClB,YAAY;QACZ,cAAc;;QAEd,UAAU;QACV,kBAAkB;IACtB;;IAEA;MACE,uBAAuB;MACvB,mBAAmB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,eAAe;IACnB;AACJ","sourcesContent":["/* ---------------------------------------------------\n    Container\n----------------------------------------------------- */\n\n.root2 {\n  background: #007bff;\n  height: 100vh;\n}\n\n\n\n#loginSistem {\n  padding: 8% 0 0;\n  margin-left: 35%;\n\n}\n\n.row {\n  width: 98%;\n}\n\n\n.formgroupbotaologin{\n  justify-content: space-between;\n}\n\n/* ---------------------------------------------------\n    Titulo\n----------------------------------------------------- */\n\n.title {\n    color: white;\n    text-align: center;\n    padding-top: 8%;\n    width: 98%;\n}\n\n.text {\n    font-size: 2.4em;\n    font-weight: bold;\n    margin-bottom: 10%;\n    width: 98%;\n}\n\n/* ---------------------------------------------------\n    Input Login\n----------------------------------------------------- */\n\ndiv #login {\n\n    border-style: hidden hidden solid hidden; \n    border-bottom: 1px solid white;\n    border-radius: 0%;\n    background: #007bff;\n    color: white;\n    width: 100%;\n}\n\n.login {\n    display: flex;\n    flex-direction: column;\n    min-width: 36px;\n  }\n  \n  .login input {\n    width: 100%;\n    height: 70px;\n    padding: 28px 16px 0 10px;\n    outline: 0;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 16px;\n  }\n  \n  .login label {\n    font-size: 16px;\n    font-family: Arial, Helvetica, sans-serif;\n    padding: 0 12px;\n    pointer-events: none;\n    position: absolute;\n    transform: translate(0, 40px) scale(1);\n    transform-origin: top left;\n    transition: all 0.5s ease-out;\n    color: white;\n  }\n\n  .login:focus-within label {\n    transform: translate(0, 12px) scale(0.75);\n  }\n\n  .login input:focus{\n    border-bottom: 2px solid #3951b2;\n  }\n\n  .login .Active {\n    transform: translate(0, 12px) scale(0.75);\n  }\n\n/* ---------------------------------------------------\n    Input Senha\n----------------------------------------------------- */\n\ndiv #senha {\n\n    border-style: hidden hidden solid hidden; \n    border-bottom: 1px solid white;\n    border-radius: 0%;\n    background: #007bff;\n    color: white;\n    width: 100%;\n    right: auto;\n    left: auto;\n    position: relative;\n}\n\n.senha {\n    display: flex;\n    flex-direction: column;\n    min-width: 36px;\n    \n  }\n  \n  .senha input {\n    width: 100%;\n    height: 70px;\n    padding: 28px 16px 0 10px;\n    outline: 0;\n    border: 1px solid white;\n    border-radius: 4px;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 16px;\n  }\n  \n  .senha label {\n    font-size: 16px;\n    font-family: Arial, Helvetica, sans-serif;\n    padding: 0 12px;\n    pointer-events: none;\n    position: absolute;\n    transform: translate(0, 40px) scale(1);\n    transform-origin: top left;\n    transition: all 0.5s ease-out;\n    color: white;\n  }\n\n  .senha:focus-within label {\n    transform: translate(0, 12px) scale(0.75);\n  }\n\n  .senha input:focus{\n    border-bottom: 2px solid #3951b2;\n  }\n\n  .senha .Active {\n    transform: translate(0, 12px) scale(0.75);\n  }\n\n/* ---------------------------------------------------\n    Botão\n----------------------------------------------------- */\n\n\ndiv #buttonlogin, div #buttonsemlogin {\n    margin-top: 2%;\n    border-radius: 0%;\n    padding-top: 1%;\n    background:white;\n    border-radius: 0%;\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); \n    border: none;\n    width: 30%;\n    position: relative;\n    float: right;\n    color: #007bff;\n}\n\n/* ---------------------------------------------------\n    Imagem\n----------------------------------------------------- */\n\n\ndiv #thinklogo{\n    max-width: 250px;\n    position: fixed;\n    bottom: 30px;\n    right: 50px;\n}\n\n/* ---------------------------------------------------\n    Material-icons\n----------------------------------------------------- */\n\nlabel .material-icons {\n    color: white;\n    vertical-align: middle;\n    transition: 0.5s; \n    padding: 0 0 0 0;\n    margin-left: -1%;\n}\n\n#buttonsemlogin .material-icons, #buttonlogin .material-icons {\n    color: #007bff;\n    vertical-align: middle;\n    transition: 0.5s; \n    padding: 0;\n}\n\n\n/* ---------------------------------------------------\n    Tela Mobile\n----------------------------------------------------- */\n\n\n@media only screen and (max-width: 769px) {\n\n    .root2 {\n      background: #007bff;\n      height: 100vh;\n      padding: 4%;\n    }\n\n\n    #loginSistem {\n        padding: 8% 0 8% 5%;\n        margin-left: 3%;\n        margin-right: 0%;\n    }\n\n    div #buttonlogin, div #buttonsemlogin {\n        margin-top: 10%;\n        border-radius: 0%;\n        padding-top: 1%;\n        background:white;\n        border-radius: 0%;\n        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); \n        border: none;\n        width: 100%;\n        position: relative;\n        float: right;\n        color: #007bff;\n\n        width: 80%;\n        padding: 10px 20px;\n    }\n\n    .formgroupbotaologin{\n      justify-content: center;\n      align-items: center;\n    }\n\n    div #thinklogo{\n        width: 100%;\n        height: 100%;\n        position: relative;\n        left: 20%;\n        margin-top: 20%;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
